import { UI, Stack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { Text, ITextProps } from 'native-base';
import React from 'react';

interface TableContentItemTextProps extends ITextProps {
  children: React.ReactNode;
  tooltip?: string | null;
}

export const TableContentItemText: React.FC<TableContentItemTextProps> = ({
  children,
  variant = 'regular',
  tooltip,
  ...rest
}) => {
  const textComponent = (
    <Text
      color="neutral.darkest"
      variant={variant}
      fontSize={Typography['fontsize.md']}
      noOfLines={1}
      {...rest}>
      {children}
    </Text>
  );

  if (tooltip) {
    return (
      <UI.Tooltip label={tooltip}>
        <Stack>{textComponent}</Stack>
      </UI.Tooltip>
    );
  }

  return textComponent;
};
